import request from '@/utils/request'

export function doAdd(data) {
  return request({
    url: '/api/workTaskRest/',
    method: 'post',
    data,
  })
}

export function doEdit(data) {
  return request({
    url: '/api/workTaskRest/',
    method: 'put',
    data,
  })
}

export function doDelete(data) {
  return request({
    url: '/api/workTaskRest/' + data,
    method: 'delete',
  })
}
